import { render, staticRenderFns } from "./AccidentDetail.vue?vue&type=template&id=444b8102&scoped=true"
import script from "./AccidentDetail.vue?vue&type=script&lang=js"
export * from "./AccidentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444b8102",
  null
  
)

export default component.exports